import { render, staticRenderFns } from "./AcceptRejected.vue?vue&type=template&id=79c5ca9f&"
import script from "./AcceptRejected.vue?vue&type=script&lang=js&"
export * from "./AcceptRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports